import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream px-5 py-10" data-id="element-126" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-127" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-semibold text-plum" data-id="element-128" data-mp="3ghc3u5juj9pt">Aura Viva 2026</p>
        <p className="mt-1 text-xs font-medium text-aura" data-id="element-129" data-mp="32pp4txyirn3c">
          Producto digital de autocuidado y bienestar.
        </p>

        <div className="mx-auto mt-5 h-px w-16 bg-gold/50" data-id="element-130" data-mp="3uf0opddwyguv" />

        <div className="mt-5 space-y-3 text-xs leading-relaxed text-plum/70" data-id="element-131" data-mp="3ufjuxwu7bgt2">
          <p data-id="element-132" data-mp="37o74x94c1ef">
            El contenido de Aura Viva 2026 tiene fines educativos y de bienestar general. No
            constituye asesoramiento médico o psicológico, no realiza diagnósticos y no reemplaza
            tratamientos ni atención profesional.
          </p>
          <p data-id="element-133" data-mp="29zgkbzgigqll">Producto 100 % digital. No se realizan envíos físicos.</p>
          <p data-id="element-134" data-mp="2a19qldn7p8t2">
            El contenido adquirido es para uso personal. No está permitida su reventa, distribución
            ni reproducción comercial.
          </p>
        </div>

        <p className="mt-6 text-xs text-plum/60" data-id="element-135" data-mp="3l9sj15twaup0">
          © {new Date().getFullYear()} Aura Viva 2026. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}